function Step2FabInfoContent({
 templateState,
 setTemplateField,

 bannerOneImageFile,
 setBannerOneImageFile,
 existingBannerOneImageUrl,
 removeBannerOneImage,
 setRemoveBannerOneImage,

 bannerTwoImageFile,
 setBannerTwoImageFile,
 existingBannerTwoImageUrl,
 removeBannerTwoImage,
 setRemoveBannerTwoImage,
}) {

 const faqItems = Array.isArray(templateState.faq_items)
  ? templateState.faq_items
  : [];

 const updateFaqItem = (index, key, value) => {
  const next = [...faqItems];

  next[index] = {
   ...next[index],
   [key]: value,
  };

  setTemplateField("faq_items", next);
 };

 const addFaqItem = () => {
  setTemplateField("faq_items", [
   ...faqItems,
   {
    question: "",
    answer_type: "text",
    answer_text: "",
    answer_lines_text: "",
    answer_items_text: "",
    link_label: "",
    link_url: "",
   },
  ]);
 };

 const removeFaqItem = (index) => {
  setTemplateField(
   "faq_items",
   faqItems.filter((_, i) => i !== index)
  );
 };

 return (
  <div className="card">
   <h2>FAB Info Content</h2>

   <label className="field">
    <span>Intro Title</span>
    <input
     type="text"
     value={templateState.intro_title || ""}
     onChange={(e) =>
      setTemplateField("intro_title", e.target.value)
     }
     placeholder="What is FAB"
    />
   </label>

   <label className="field">
    <span>Intro Text</span>
    <textarea
     rows="5"
     value={templateState.intro_text || ""}
     onChange={(e) =>
      setTemplateField("intro_text", e.target.value)
     }
     placeholder="Fast Action Basketball (FAB) is a nonprofit 501(c)4 adult basketball league operating in multiple locations in Southern California..."
    />
   </label>

   <div className="field">
    <span>FAQ Items</span>

    <div style={{ display: "grid", gap: "1rem", marginTop: "0.75rem" }}>
     {faqItems.map((item, index) => (
      <div
       key={index}
       style={{
        border: "1px solid #ddd",
        borderRadius: "10px",
        padding: "1rem",
       }}
      >
       <label className="field">
        <span>Question</span>
        <input
         type="text"
         value={item.question || ""}
         onChange={(e) => updateFaqItem(index, "question", e.target.value)}
         placeholder="How many seasons in FAB?"
        />
       </label>

       <label className="field">
        <span>Answer Type</span>
        <select
         value={item.answer_type || "text"}
         onChange={(e) => updateFaqItem(index, "answer_type", e.target.value)}
        >
         <option value="text">Text</option>
         <option value="list">Bullet List</option>
         <option value="ordered_list">Numbered List</option>
         <option value="link_text">Text + Link</option>
         <option value="ordered_list_with_links">Numbered List + Links</option>
        </select>
       </label>

       {(item.answer_type === "text" || item.answer_type === "link_text") && (
        <label className="field">
         <span>Answer Text</span>
         <textarea
          rows="4"
          value={item.answer_text || ""}
          onChange={(e) => updateFaqItem(index, "answer_text", e.target.value)}
          placeholder="Teams in good standing play 9-12 games including playoffs."
         />
        </label>
       )}

       {(item.answer_type === "list" || item.answer_type === "ordered_list") && (
        <label className="field">
         <span>Answer Lines</span>
         <textarea
          rows="6"
          value={item.answer_lines_text || ""}
          onChange={(e) =>
           updateFaqItem(index, "answer_lines_text", e.target.value)
          }
          placeholder={`SPRING (January Registration)
SUMMER (May Registration)
FALL (September Registration)`}
         />
         <div className="field-help">
          Put one line per item.
         </div>
        </label>
       )}

       {item.answer_type === "ordered_list_with_links" && (
        <label className="field">
         <span>Answer Items</span>
         <textarea
          rows="8"
          value={item.answer_items_text || ""}
          onChange={(e) =>
           updateFaqItem(index, "answer_items_text", e.target.value)
          }
          placeholder={`Build a team. Choose a captain.
Captains: complete | Team Registration | https://example.com/team
Players: complete | Player Registration | https://example.com/player
Pay your fee.
Respect our staff (zero tolerance policy).
Play your heart out.`}
         />
         <div className="field-help">
          One line per item. For a linked line use: text | link label | link url
         </div>
        </label>
       )}

       {item.answer_type === "link_text" && (
        <>
         <label className="field">
          <span>Link Label</span>
          <input
           type="text"
           value={item.link_label || ""}
           onChange={(e) =>
            updateFaqItem(index, "link_label", e.target.value)
           }
           placeholder="Season start dates"
          />
         </label>

         <label className="field">
          <span>Link URL</span>
          <input
           type="text"
           value={item.link_url || ""}
           onChange={(e) =>
            updateFaqItem(index, "link_url", e.target.value)
           }
           placeholder="/fastactionbasketball/registration"
          />
         </label>
        </>
       )}

       <button
        type="button"
        className="secondary-btn"
        onClick={() => removeFaqItem(index)}
       >
        Remove FAQ
       </button>
      </div>
     ))}
    </div>

    <div style={{ marginTop: "1rem" }}>
     <button type="button" className="secondary-btn" onClick={addFaqItem}>
      Add FAQ
     </button>
    </div>
   </div>

   <label className="field">
    <span>Banner One Title</span>
    <input
     type="text"
     value={templateState.banner_one_title || ""}
     onChange={(e) =>
      setTemplateField("banner_one_title", e.target.value)
     }
     placeholder="It's not about the competition..."
    />
   </label>

   <label className="field">
    <span>Banner One Image</span>
    <input
     type="file"
     accept="image/*"
     onChange={(e) => setBannerOneImageFile(e.target.files?.[0] || null)}
    />
    {existingBannerOneImageUrl ? (
     <div className="field-help">
      Current image: {existingBannerOneImageUrl}
     </div>
    ) : null}
    <label
     style={{
      display: "flex",
      gap: "0.5rem",
      alignItems: "center",
      marginTop: "0.5rem",
     }}
    >
     <input
      type="checkbox"
      checked={removeBannerOneImage}
      onChange={(e) => setRemoveBannerOneImage(e.target.checked)}
     />
     <span>Remove current image</span>
    </label>
   </label>

   <label className="field">
    <span>Banner Two Title</span>
    <input
     type="text"
     value={templateState.banner_two_title || ""}
     onChange={(e) =>
      setTemplateField("banner_two_title", e.target.value)
     }
     placeholder="... it's about conquering yourself."
    />
   </label>

   <label className="field">
    <span>Banner Two Image</span>
    <input
     type="file"
     accept="image/*"
     onChange={(e) => setBannerTwoImageFile(e.target.files?.[0] || null)}
    />
    {existingBannerTwoImageUrl ? (
     <div className="field-help">
      Current image: {existingBannerTwoImageUrl}
     </div>
    ) : null}
    <label
     style={{
      display: "flex",
      gap: "0.5rem",
      alignItems: "center",
      marginTop: "0.5rem",
     }}
    >
     <input
      type="checkbox"
      checked={removeBannerTwoImage}
      onChange={(e) => setRemoveBannerTwoImage(e.target.checked)}
     />
     <span>Remove current image</span>
    </label>
   </label>
  </div>
 );
}

export default Step2FabInfoContent;